import React from 'react'
import { Head, withRouteData } from 'react-static'
import styled from 'styled-components'

import GalleryMain from '../components/pages/gallery/GalleryMain'
import Sidebar from '../components/common/sidebar/Sidebar'

import { gallery } from '../data/gallery'

const Wrapper = styled.div`
  z-index: 1;
  position: relative;
  padding: 0;
  background-color: #fff;

  @media screen and (min-width: 801px) and (max-width: 1919px) {
    padding-left: 20em;
  }

  @media screen and (min-width: 1920px) {
    padding-left: 25em;
  }
`

const Gallery = ({ match }) => {
  const current = gallery.filter(([name, data]) => match.url.includes(name))[0]

  return (
    <Wrapper>
      <Head>
        <title>Gallery</title>
      </Head>
      {current && (
        <React.Fragment>
          <Sidebar title="gallery" data={gallery} current={current[0]} />
          <GalleryMain category={current[0]} items={current[1].items} />
        </React.Fragment>
      )}
    </Wrapper>
  )
}

export default withRouteData(Gallery)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Gallery.js